const blop = require("!/Users/batistebieler/project/blop-language/src/runtime.js");
let { MemeCard } = require('./MemeCard.blop');
let { getMemes } = require('./services.blop');

function MemePage(attributes, _children, node) {
  let { state } = attributes;
  node.mount(async () => {
    console.log('mount MemePage');
    await getMemes(state);
  });
  const __1c = []; const __1a = {};
    const __2c = []; const __2a = {}; __2a['class'] = ({ 'card-deck': true, 'mb-3': true, 'text-center': true });
      let __4 = state.memes; let _i__3=0; for(; _i__3 < __4.length; _i__3++) { let meme = __4[_i__3];
        const __5c = []; const __5a = {}; __5a['meme'] = meme; const __5 = blop.c(MemeCard, __5a, __5c, '__5'); __2c.push(__5);
      };
     const __2 = blop.h('div', __2a, __2c); __1c.push(__2);
   const __1 = blop.h('div', __1a, __1c); return __1;
};
module.exports = { MemeCard, getMemes, MemePage };
